import React from "react";
import {ThemeProvider} from "@chakra-ui/core";

import {ClientTenant} from "./types";

import getTheme from "~/theme";

export interface Context {
  state: {
    tenant: ClientTenant;
  };
}

interface Props {
  initialValue: ClientTenant;
}

const TenantContext = React.createContext({} as Context);

const TenantProvider: React.FC<Props> = ({children, initialValue: tenant}) => {
  const state: Context["state"] = {tenant};

  return (
    <ThemeProvider theme={getTheme(tenant.color)}>
      <TenantContext.Provider value={{state}}>{children}</TenantContext.Provider>
    </ThemeProvider>
  );
};

export {TenantProvider as Provider, TenantContext as default};
